import { render, staticRenderFns } from "./FormInputCheckboxWidget.vue?vue&type=template&id=22d84b24&"
import script from "./FormInputCheckboxWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputCheckboxWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports